import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";

import useHospitalAdd from "../../useHospitalAdd";
import { APP_URL } from "../../../../../Utils/AppConstance";
import { genericFetchData } from "../../../../../Services/Service";

import AgreementTable from "../../../../../Components/Pages/Agreement/AgreementTable";
import AgreementData from "../../../../../Components/Pages/Agreement/AgreementData";
import AgreementUpload from "../../../../../Components/Pages/Agreement/AgreementUpload";
import { checkPermission } from "../../../../../Utils/Permissions";
import ToastSnackbar from "../../../../../Components/ToastSnackbar/ToastSnackbar";
import { parseErrorMessage } from "../../../../../Utils/helper";
import { getUserRole } from "../../../../../Storage/Datastore";

function Agreement({
  hospitalId,
  isReadOnly,
  setIsReadOnly,
  showApproval,
  setshowApproval,
}) {
  const { doc, setDoc, ...state } = useHospitalAdd();
  const navigate = useNavigate();
  const userRole = getUserRole();
  const [showTable, setShowTable] = useState(false);
  const [showPreview, setShowPreview] = useState(true);
  const [open, setOpen] = useState(false);
  // const [showApproval, setshowApproval] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [tableData, setTableData] = useState(false);
  // const [isReadOnly, setIsReadOnly] = useState(true);
  const [agreementData, setAgreementData] = useState({
    contactPersonName: "",
    contactPersonNumber: "",
    agreementStartDate: "",
    agreementEndDate: "",
    hospitalId: hospitalId,
    hospitalDoc: [],
    document: [],
    image: [],
    hospitalImage: [],
    documentIds: [],
  });

  const saveAgreementDetails = async () => {
    try {
      const formData = new FormData();

      if (agreementData.hospitalDoc.length > 0) {
        formData.append("document", agreementData.hospitalDoc[0]);
      }

      formData.append(
        "contactPersonName",
        agreementData.contactPersonName ||
        tableData.agreementResponse?.contactPersonName
      );
      formData.append(
        "contactPersonNumber",
        agreementData.contactPersonNumber ||
        tableData.agreementResponse?.contactPersonNumber
      );
      formData.append(
        "agreementStartDate",
        agreementData.agreementStartDate ||
        tableData.agreementResponse?.agreementStartDate
      );
      formData.append(
        "agreementEndDate",
        agreementData.agreementEndDate ||
        tableData.agreementResponse?.agreementEndDate
      );
      formData.append("centerId", agreementData.hospitalId);

      const url = `${APP_URL}/center/agreement/save`;
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setShowPreview(false);
        getAgreementData();
        handleToast(false);
        setshowApproval();
        const responseData = await response.json();
        return responseData;
      } else {
        const text = await response.json();
        handleToast(true);
        setToastMessage(parseErrorMessage(text.errorMessage));
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      // handleToast(true);
      // setToastMessage("Error, failed to save agreement details", error.message);
      console.log("Failed to save agreement details:", error);
    }
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return; //
    }
    setOpen(false);
  };

  const handleToast = (error) => {
    setOpen(true);
    if (error) {
      setToastMessage("Error");
    } else {
      setToastMessage("Success");
    }
  };

  const getAgreementData = async () => {
    try {
      const response = await genericFetchData(
        `/center/agreementData?centerId=${agreementData.hospitalId}&isDownload=false`,
        "GET"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log(responseData);
      setTableData(responseData);
    } catch (error) {
      console.log(error);
    }
  };

  const sendHospitalApproval = async () => {
    // const postData = { hospitalId: agreementData.hospitalId };
    http: try {
      console.log("APP_URL========:", APP_URL);

      const response = await fetch(
        `${APP_URL}/center/agreement/approval/send?centerId=${agreementData.hospitalId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(postData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log("Success:");
      setTimeout(() => {
        navigate("/mySpace");
      }, 1000);
      handleToast(false);
      setToastMessage("Approval send successfully");
    } catch (error) {
      handleToast(true);
      setToastMessage("Error sending approval");
    }
  };

  const getSampleAgreementFile = async () => {
    try {
      const response = await genericFetchData(
        `/center/agreementData?centerId=${hospitalId}&isDownload=true`,
        "GET"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "agreement.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAgreementData();
  }, []);

  useEffect(() => {
    tableData?.agreementResponse?.agreementEndDate
      ? setIsReadOnly(true)
      : setIsReadOnly(false);
    setShowTable(true);
  }, [tableData]);

  useEffect(() => { }, [isReadOnly]);

  return (
    <Grid margin={2}>
      <Typography
        sx={{ color: "#20BB9E", fontSize: 16, fontWeight: 500, paddingY: 4 }}
      >
        Agreements
      </Typography>
      <AgreementData
        setAgreementData={setAgreementData}
        agreementData={agreementData}
        readonlyData={tableData}
        isReadOnly={isReadOnly}
        isLive={state.isLive}
      />
      {checkPermission("KARE_DB_FINANCE_EDIT") && !state.isLive && (
        <AgreementUpload
          setAgreementData={setAgreementData}
          isReadOnly={isReadOnly}
          agreementData={agreementData}
          handleSave={saveAgreementDetails}
          showPreview={showPreview}
          setShowTable={setShowTable}
          getAgreementData={getAgreementData}
          getSampleAgreementFile={getSampleAgreementFile}
        />
      )}

      <Grid paddingY={5}>
        <AgreementTable showTable={showTable} doctor tableDataa={tableData} />
      </Grid>

      {!showApproval && (
        <Grid textAlign={"end"}>
          {checkPermission("KARE_DB_FINANCE_EDIT") && !state.isLive && (
            <Box
              width={"155px"}
              fontSize={"14px"}
              border={"#414851"}
              sx={{
                textTransform: "capitalize",
                color: "black",
                bgcolor: "#20BB9E",
                fontWeight: 500,
                alignSelf: "flex-end",
              }}
              height={"46px"}
              component={Button}
              onClick={() => sendHospitalApproval()}
            >
              Send for Approval
            </Box>
          )}
        </Grid>
      )}

      <ToastSnackbar
        handleOpen={open}
        message={toastMessage}
        onClose={handleCloseToast}
      />
    </Grid>
  );
}

export default Agreement;
